import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { ContractorServiceZipApiService } from '../index';
import { IContractorServiceZip, IContractorServiceZipInput, DeleteContractorServiceZipMutation } from '@ebb-v2/ebb-integration';

import { Apollo} from 'apollo-angular';
import { GetContractorServiceZipsByIdQuery, SaveContractorServiceZipMutation } from '@ebb-v2/ebb-integration';

@Injectable({
    providedIn: 'root'
  })
export class ContractorServiceZipGqlService implements ContractorServiceZipApiService {
  constructor(
    private apollo: Apollo
  ) { }

  public get (contactId: string) : Observable<IContractorServiceZip[]> {
    //console.log(`ContractorServiceZipGql.get()`);
    return this.apollo
      .watchQuery({
        query: GetContractorServiceZipsByIdQuery,
        variables: {
          contactId: contactId,
        },
        fetchPolicy: 'network-only'
      })
      .valueChanges
      .pipe(map(result => result.data['contractorServiceZip'] as IContractorServiceZip[]), take(1));
  }

  public save (contractServiceZip: IContractorServiceZipInput): Observable<IContractorServiceZip> {
    //console.log(`ContractorServiceZipGql.save()`);
    return this.apollo
      .mutate({
        mutation: SaveContractorServiceZipMutation,
        variables : {
          contractServiceZip
        }
      })
      .pipe(map(result => result.data['saveContractorServiceZip'] as IContractorServiceZip));
  }

  public delete(contractServiceZip: IContractorServiceZipInput): Observable<IContractorServiceZip> {
    //console.log(`ContractorServiceZipGql.save()`);
    return this.apollo
      .mutate({
        mutation: DeleteContractorServiceZipMutation,
        variables: {
          contractServiceZip
        }
      })
      .pipe(map(result => result.data['deleteContractorServiceZip'] as IContractorServiceZip));
  }
}
